import { z } from 'zod';
// Order documents (WMS-28) are PDFs only. Kept separate from the photo schemas
// so the two upload paths can never accept each other's content types.
const ALLOWED_DOC_MIME = ['application/pdf'];
const MAX_DOC_BYTES = 25 * 1024 * 1024; // 25 MiB — must match PhotosService
export const documentUploadUrlSchema = z.object({
    contentType: z.enum(ALLOWED_DOC_MIME),
    sizeBytes: z.number().int().positive().max(MAX_DOC_BYTES),
});
export const documentConfirmSchema = z.object({
    objectKey: z.string().min(1).max(512),
    contentType: z.enum(ALLOWED_DOC_MIME),
    sizeBytes: z.number().int().positive().max(MAX_DOC_BYTES),
    /** Original file name, shown in the UI. */
    filename: z.string().trim().min(1).max(255),
});
export const documentDeleteSchema = z.object({
    objectKey: z.string().min(1).max(512),
});
//# sourceMappingURL=document.js.map